import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdminProviderState {
  providers: any[];
  loading: boolean;
  error: string | null;
}

const initialState: AdminProviderState = {
  providers: [],
  loading: false,
  error: null,
};

const adminProviderSlice = createSlice({
  name: "adminProvider",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    endLoading(state) {
      state.loading = false;
    },
    setProviders(state, action: PayloadAction<any[]>) {
      state.providers = action.payload;
      state.loading = false;
    },
    removeProvider(state, action: PayloadAction<number>) {
      state.providers = state.providers.filter((p) => p.id !== action.payload);
      state.loading = false;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const adminProviderActions = adminProviderSlice.actions;
export default adminProviderSlice;
